import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/home';
import Friends from './Pages/friends';
import Wishes from './Pages/wishes';
import Cart from './Pages/cart';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Friends" element={<Friends />} />
            <Route path="/Wishlist" element={<Wishes />} />
          <Route path="/Cart" element={<Cart />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;